import { useState } from "react";

/**
 * Custom hook to manage modal visibility and state.
 * @returns {
 * isVisible: boolean, // Modal visibility state
 * data: any, // Data to be displayed in the modal
 * openModal: (newData: any) => void, // Function to open the modal with data
 * closeModal: () => void // Function to close the modal
 * } Contains modal visibility state, data state, and functions to open/close the modal with data
 */
const useModal = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [data, setData] = useState(null);

    // Open the modal with data
    const openModal = (newData) => {
        setData(newData);
        setIsVisible(true);
    };

    const closeModal = () => {
        setIsVisible(false);
        setData(null);
    };

    return {
        isVisible,
        data,
        openModal,
        closeModal,
    };
};

export default useModal;
